// ----------------------------------------------------------------------

export const role = [
  'UI/UX Designer',
  'Programmer'
];
